import {
  pick, omitBy, isNil, omit,
} from 'lodash'
import { isFeatureEnabled } from '@/store/modules/feature-toggles.module'
import { isColorLight } from '@/utils/color.util'

const DEFAULT_THEME_ATTRIBUTES = {
  textColour: '#313131',
  baseColour: '#ffffff',
  backgroundImage: null,
  visibility: 20,
}

const THEME_ATTRIBUTES = ['themeName', 'textColour', 'baseColour', 'visibility', 'backgroundImage', 'themeThumbnail', 'themeId', 'themeActive', 'colorPalette', 'logo', 'fontFamily']
const _state = {}

const nullifiedThemeEmptyField = (slide) => {
  const nullifiedSlide = {
    ...slide,
    textColour: slide.textColour === '' ? null : slide.textColour,
    baseColour: slide.baseColour === '' ? null : slide.baseColour,
    // In Presenter there is a function that consider slide visibility null as 100
    // You guy can check in stpancras-presenter-app/src/components-v2/presentation-editor/middle/CanvasTransitionBackgroundImage.vue
    // slideVisibility()
    // This function is not available in audience app, but set it 100 here has the same behavior
    // There would be 2 possible solutions:
    // 1. Refactor the slideVisibility => null = 0 => But the result is the background display gonna be changes, and user in presenter app have
    // to update the visibility manually to 100 to correct the display.
    // 2. Set visibility to 100 here
    // This may cause confusion, but many user use this feature before are getting along with this issue. So I decided to keep it as it is.
    visibility: slide.visibility === -1 ? 100 : slide.visibility,
  }

  return omitBy(nullifiedSlide, isNil)
}

const _getters = {
  canViewThemeGallery: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'release-theme-gallery')
  },
  currentPresentationTheme: (_, __, rootState) => {
    const attribute = rootState.presentationAttributeModule.presentationAttribute
    const themeAttribute = pick(attribute, THEME_ATTRIBUTES)

    return {
      ...DEFAULT_THEME_ATTRIBUTES,
      ...themeAttribute,
    }
  },
  activeActivityWithTheme: (_, getters, __, rootGetters) => {
    const activeActivity = rootGetters?.activeActivity
    const presentationTheme = getters.currentPresentationTheme

    if (getters.canViewThemeGallery) {
      return {
        // We don't need these theme attributes since these attributes are rendered in another layer
        ...omit(presentationTheme, ['backgroundImage']),
        ...nullifiedThemeEmptyField(activeActivity),
      }
    }

    return activeActivity
  },
  isTextColourLight: (_, getters, __, rootGetters) => {
    const activeActivity = rootGetters?.activeActivity
    const { activeActivityWithTheme } = getters
    if (getters.canViewThemeGallery) {
      return isColorLight(activeActivityWithTheme.textColour)
    }

    return activeActivity.textColour === '#ffffff'
  },
  activeActivityBaseColour: (_, __, ___, rootGetters) => {
    const { baseColour } = nullifiedThemeEmptyField(rootGetters?.activeActivity)

    return baseColour
  },
  contrastBackgroundColour: (_, getters) => {
    const { textColour, baseColour } = getters?.activeActivityWithTheme
    if (getters.canViewThemeGallery) {
      // To make sure it always contrast with the text colour
      return isColorLight(textColour)
        ? DEFAULT_THEME_ATTRIBUTES.textColour
        : DEFAULT_THEME_ATTRIBUTES.baseColour
    }
    return baseColour
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
}
